import { render, staticRenderFns } from "./MolIconButton.vue?vue&type=template&id=6b00e506&scoped=true&"
import script from "./MolIconButton.vue?vue&type=script&lang=ts&"
export * from "./MolIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./MolIconButton.vue?vue&type=style&index=0&id=6b00e506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b00e506",
  null
  
)

export default component.exports